"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderRiskWidget = exports.initializeRMSWidget = void 0;
var renderRiskWidget = function renderRiskWidget(src) {
  if (!document.getElementById('risk-widget-script')) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.defer = true;
      script.setAttribute('id', 'risk-widget-script');
      script.addEventListener('load', function () {
        resolve();
      });
      script.addEventListener('error', function (e) {
        reject(e);
      });
      document.body.appendChild(script);
    });
  } else {
    return new Promise(function (resolve, _reject) {
      resolve(document.getElementById('risk-widget-script'));
    });
  }
};
exports.renderRiskWidget = renderRiskWidget;
var initializeRMSWidget = function initializeRMSWidget(config) {
  var widget = new RMSWidget(config);
  widget.initialize();
};
exports.initializeRMSWidget = initializeRMSWidget;